import { Icon_default } from "./chunk-HALE5GZ6.js";

// src/elements/Icon/helpers.tsx
import { jsx } from "react/jsx-runtime";
var renderIcon = icon => typeof icon === "string" ? /* @__PURE__ */jsx(Icon_default, {
  icon
}) : icon;
export { renderIcon };